import { IFooterLinkModel } from 'src/interfaces/interface';

const imageUrl = "https://d3lzbbhyvqc4k.cloudfront.net/images-webp/";

export class FooterListModel {
    static paymentAcceptArray = [
        {
            img: imageUrl + "homepage-icons/visa.webp",
            name: 'VISA'
        },
        {
            img: imageUrl + "homepage-icons/mastercard.webp",
            name: 'Mastercard'
        },
        {
            img: imageUrl + "homepage-icons/amex.webp",
            name: 'AMEX'
        },
        {
            img: imageUrl + 'homepage-icons/discover.webp',
            name: 'Discover'
        },
        {
            img: imageUrl + 'homepage-icons/rupay.webp',
            name: 'RuPay'
        },
        {
            img: imageUrl + 'homepage-icons/banking.webp',
            name: 'Banking'
        }, {
            img: imageUrl + 'homepage-icons/cod.webp',
            name: 'COD'
        }

    ];

    static socialShareIconArray = [
        {
            // img: 'fa fa-linkedin fa-2x',
             name: 'LinkedIn',
             url: 'https://www.linkedin.com/company/taxmann/',
             svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g clip-path="url(#clip0_1701_13595)">
 <path d="M22.2234 0.444336H1.77187C0.792187 0.444336 0 1.21777 0 2.17402V22.71C0 23.6662 0.792187 24.4443 1.77187 24.4443H22.2234C23.2031 24.4443 24 23.6662 24 22.7146V2.17402C24 1.21777 23.2031 0.444336 22.2234 0.444336ZM7.12031 20.8959H3.55781V9.43965H7.12031V20.8959ZM5.33906 7.87871C4.19531 7.87871 3.27188 6.95527 3.27188 5.81621C3.27188 4.67715 4.19531 3.75371 5.33906 3.75371C6.47813 3.75371 7.40156 4.67715 7.40156 5.81621C7.40156 6.95059 6.47813 7.87871 5.33906 7.87871ZM20.4516 20.8959H16.8937V15.3271C16.8937 14.0006 16.8703 12.2896 15.0422 12.2896C13.1906 12.2896 12.9094 13.7381 12.9094 15.2334V20.8959H9.35625V9.43965H12.7687V11.0053H12.8156C13.2891 10.1053 14.4516 9.15371 16.1813 9.15371C19.7859 9.15371 20.4516 11.5256 20.4516 14.61V20.8959Z" fill="#98A2B3"/>
 </g>
 <defs>
 <clipPath id="clip0_1701_13595">
 <rect width="24" height="24" fill="white" transform="translate(0 0.444336)"/>
 </clipPath>
 </defs>
 </svg>
 `
         },
         {
            //  img: 'fa fa-twitter fa-2x',
              name: 'Twitter',
              url: 'https://twitter.com/taxmannindia',
              svg: `<svg viewBox="0 0 24 24" aria-hidden="true"><g><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></g></svg>`
          },           
       
         {
             // img: 'fa fa-facebook-official fa-2x',
              name: 'Whatsapp',
              url: 'https://taxmann.social/ayDWB',
              svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4 3.89531C18.15 1.64531 15.15 0.445312 12 0.445312C5.4 0.445312 0 5.84531 0 12.4453C0 14.5453 0.600009 16.6453 1.65001 18.4453L0 24.4453L6.30002 22.7953C8.10002 23.6953 10.05 24.2953 12 24.2953C18.6 24.2953 24 18.8953 24 12.2953C24 9.14531 22.65 6.14531 20.4 3.89531ZM12 22.3453C10.2 22.3453 8.40001 21.8953 6.90001 20.9953L6.59999 20.8453L2.84999 21.8953L3.90001 18.2953L3.59999 17.8453C2.54999 16.1953 2.09999 14.3953 2.09999 12.5953C2.09999 7.19531 6.6 2.69531 12 2.69531C14.7 2.69531 17.1 3.74531 19.05 5.54531C21 7.49531 21.9 9.89531 21.9 12.5953C21.9 17.8453 17.55 22.3453 12 22.3453ZM17.4 14.8453C17.1 14.6953 15.6 13.9453 15.3 13.9453C15 13.7953 14.85 13.7953 14.7 14.0953C14.55 14.3953 13.95 14.9953 13.8 15.2953C13.65 15.4453 13.5 15.4453 13.2 15.4453C12.9 15.2953 12 14.9953 10.8 13.9453C9.90002 13.1953 9.30001 12.1453 9.15001 11.8453C9.00001 11.5453 9.15002 11.3953 9.30002 11.2453C9.45002 11.0953 9.6 10.9453 9.75 10.7953C9.9 10.6453 9.90002 10.4953 10.05 10.3453C10.2 10.1953 10.05 10.0453 10.05 9.89531C10.05 9.74531 9.45001 8.24531 9.15001 7.64531C9.00001 7.19531 8.70002 7.19531 8.55002 7.19531C8.40002 7.19531 8.24998 7.19531 7.94998 7.19531C7.79998 7.19531 7.49998 7.19531 7.19998 7.49531C6.89998 7.79531 6.15001 8.54531 6.15001 10.0453C6.15001 11.5453 7.19999 12.8953 7.34999 13.1953C7.49999 13.3453 9.44998 16.4953 12.45 17.6953C15 18.7453 15.45 18.4453 16.05 18.4453C16.65 18.4453 17.85 17.6953 18 17.0953C18.3 16.3453 18.3 15.7453 18.15 15.7453C18 14.9953 17.7 14.9953 17.4 14.8453Z" fill="#98A2B3"/>
              </svg>              
              ` 
          },
          {
            // img: 'fa fa-telegram fa-2x',
             name: 'Telegram',
             url: 'https://t.me/taxmannprofessionals',
             svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g clip-path="url(#clip0_1701_13603)">
 <path d="M12 24.4443C18.629 24.4443 24 19.0733 24 12.4443C24 5.81534 18.629 0.444336 12 0.444336C5.371 0.444336 0 5.81534 0 12.4443C0 19.0733 5.371 24.4443 12 24.4443ZM5.491 12.1843L17.061 7.72334C17.598 7.52934 18.067 7.85434 17.893 8.66634L17.894 8.66534L15.924 17.9463C15.778 18.6043 15.387 18.7643 14.84 18.4543L11.84 16.2433L10.393 17.6373C10.233 17.7973 10.098 17.9323 9.788 17.9323L10.001 14.8793L15.561 9.85634C15.803 9.64334 15.507 9.52334 15.188 9.73534L8.317 14.0613L5.355 13.1373C4.712 12.9333 4.698 12.4943 5.491 12.1843Z" fill="#98A2B3"/>
 </g>
 <defs>
 <clipPath id="clip0_1701_13603">
 <rect width="24" height="24" fill="white" transform="translate(0 0.444336)"/>
 </clipPath>
 </defs>
 </svg>
 `
         },


         {
            //img: 'fa fa-youtube-play fa-2x',
            name: 'YouTube',
            url: 'https://www.youtube.com/user/TaxmannPublications?sub_confirmation=1',
            svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.7747 6.82053C22.5154 5.85661 21.7554 5.09677 20.7916 4.83722C19.0309 4.35547 11.988 4.35547 11.988 4.35547C11.988 4.35547 4.94536 4.35547 3.18466 4.81895C2.23943 5.07823 1.46091 5.85675 1.20163 6.82053C0.738281 8.58109 0.738281 12.2323 0.738281 12.2323C0.738281 12.2323 0.738281 15.9018 1.20163 17.644C1.46118 18.6078 2.22089 19.3676 3.1848 19.6272C4.9639 20.109 11.9883 20.109 11.9883 20.109C11.9883 20.109 19.0309 20.109 20.7916 19.6456C21.7555 19.3861 22.5154 18.6263 22.7749 17.6625C23.2381 15.9018 23.2381 12.2508 23.2381 12.2508C23.2381 12.2508 23.2567 8.58109 22.7747 6.82053ZM9.7457 15.6053V8.85918L15.6022 12.2323L9.7457 15.6053Z" fill="#98A2B3"/>
</svg>
`
        },
        {
            name: 'Google News',
            url: 'https://news.google.com/publications/CAAqBwgKMJP7lQsw1p6tAw?hl=en-IN&gl=IN&ceid=IN%3Aen',
            svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1701_13605)">
            <path d="M4.29851 6.01251L4.88486 3.06494L12.0009 4.48038L19.117 3.06494L19.7033 6.01251L20.8319 6.23697V1.17773H3.16992V6.23697L4.29851 6.01251Z" fill="#98A2B3"/>
            <path d="M24.0008 8.3007L20 7.50488L20.4744 9.89018H22.2373V17.1668L24.0008 8.3007Z" fill="#98A2B3"/>
            <path d="M8.39731 5.19708L5.98761 4.71777L5.78906 5.71593L8.39731 5.19708Z" fill="#98A2B3"/>
            <path d="M19.0406 9.89001L18.0118 4.71777L0 8.30052L1.76357 17.1666V9.89001H19.0406Z" fill="#98A2B3"/>
            <path d="M20.8319 11.2949H3.16992V23.7098H20.8319V11.2949ZM14.8821 16.7996H18.7237V18.2051H14.8821V16.7996ZM18.7237 13.9887V15.3942H14.8821V13.9887H18.7237ZM9.37737 21.6016C7.11701 21.6016 5.27811 19.7627 5.27811 17.5024C5.27811 15.242 7.11701 13.4031 9.37737 13.4031C10.4349 13.4031 11.4389 13.8047 12.2044 14.5339L11.2351 15.5516C10.7321 15.0724 10.0724 14.8086 9.37737 14.8086C7.89198 14.8086 6.68357 16.017 6.68357 17.5024C6.68357 18.9878 7.89198 20.1962 9.37737 20.1962C10.6197 20.1962 11.6683 19.3507 11.9782 18.2051H9.37737V16.7996H13.4766V17.5024C13.4766 19.7627 11.6377 21.6016 9.37737 21.6016ZM14.8821 19.6106H18.7237V21.016H14.8821V19.6106Z" fill="#98A2B3"/>
            </g>
            <defs>
            <clipPath id="clip0_1701_13605">
            <rect width="24" height="24" fill="white" transform="translate(0 0.444336)"/>
            </clipPath>
            </defs>
            </svg>
            `
        },
        {
           // img: 'fa fa-instagram fa-2x',
            name: 'Instagram',
            url: 'https://www.instagram.com/taxmannindia/',
            svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1701_13599)">
<path d="M23.9773 7.5004C23.9211 6.22519 23.7149 5.34849 23.4195 4.58882C23.1147 3.78245 22.6459 3.06051 22.0316 2.46035C21.4315 1.85086 20.7048 1.37726 19.9078 1.07727C19.1437 0.781865 18.2716 0.575648 16.9964 0.519424C15.7116 0.458438 15.3038 0.444336 12.0453 0.444336C8.78686 0.444336 8.37901 0.458438 7.09903 0.514662C5.82382 0.570887 4.94712 0.777287 4.18764 1.07251C3.38108 1.37726 2.65914 1.8461 2.05899 2.46035C1.44949 3.06051 0.976073 3.78721 0.675905 4.58424C0.380498 5.34849 0.174281 6.22043 0.118057 7.49564C0.0570706 8.78038 0.0429688 9.18823 0.0429688 12.4467C0.0429688 15.7051 0.0570706 16.113 0.113295 17.393C0.169519 18.6682 0.37592 19.5449 0.671326 20.3045C0.976073 21.1109 1.44949 21.8329 2.05899 22.433C2.65914 23.0425 3.38585 23.5161 4.18288 23.8161C4.94712 24.1115 5.81906 24.3177 7.09446 24.3739C8.37425 24.4303 8.78229 24.4443 12.0407 24.4443C15.2992 24.4443 15.707 24.4303 16.987 24.3739C18.2622 24.3177 19.1389 24.1115 19.8984 23.8161C21.5113 23.1925 22.7865 21.9173 23.4101 20.3045C23.7054 19.5403 23.9118 18.6682 23.968 17.393C24.0242 16.113 24.0383 15.7051 24.0383 12.4467C24.0383 9.18823 24.0336 8.78038 23.9773 7.5004ZM21.8161 17.2992C21.7644 18.4713 21.5676 19.1042 21.4035 19.5262C21.0002 20.5717 20.1704 21.4016 19.1248 21.8048C18.7029 21.9689 18.0653 22.1658 16.8978 22.2173C15.632 22.2737 15.2523 22.2876 12.0501 22.2876C8.84785 22.2876 8.46344 22.2737 7.20214 22.2173C6.03004 22.1658 5.3971 21.9689 4.97515 21.8048C4.45484 21.6125 3.98124 21.3078 3.59682 20.9093C3.19831 20.5201 2.89356 20.0513 2.70126 19.5309C2.53717 19.109 2.34029 18.4713 2.28883 17.304C2.23242 16.0381 2.2185 15.6582 2.2185 12.456C2.2185 9.2538 2.23242 8.86938 2.28883 7.60827C2.34029 6.43617 2.53717 5.80323 2.70126 5.38127C2.89356 4.86079 3.19831 4.38737 3.60159 4.00277C3.99058 3.60425 4.45942 3.29951 4.97991 3.10739C5.40187 2.9433 6.03956 2.74642 7.2069 2.69478C8.47278 2.63855 8.85261 2.62445 12.0547 2.62445C15.2616 2.62445 15.6413 2.63855 16.9026 2.69478C18.0747 2.74642 18.7076 2.9433 19.1296 3.10739C19.6499 3.29951 20.1235 3.60425 20.5079 4.00277C20.9064 4.39195 21.2112 4.86079 21.4035 5.38127C21.5676 5.80323 21.7644 6.44075 21.8161 7.60827C21.8723 8.87414 21.8864 9.2538 21.8864 12.456C21.8864 15.6582 21.8723 16.0333 21.8161 17.2992Z" fill="#98A2B3"/>
<path d="M12.0442 6.28125C8.64049 6.28125 5.87891 9.04265 5.87891 12.4465C5.87891 15.8504 8.64049 18.6118 12.0442 18.6118C15.448 18.6118 18.2094 15.8504 18.2094 12.4465C18.2094 9.04265 15.448 6.28125 12.0442 6.28125ZM12.0442 16.4458C9.83604 16.4458 8.04492 14.6548 8.04492 12.4465C8.04492 10.2382 9.83604 8.44726 12.0442 8.44726C14.2525 8.44726 16.0434 10.2382 16.0434 12.4465C16.0434 14.6548 14.2525 16.4458 12.0442 16.4458Z" fill="#98A2B3"/>
<path d="M19.8925 6.03794C19.8925 6.83277 19.248 7.47725 18.453 7.47725C17.6581 7.47725 17.0137 6.83277 17.0137 6.03794C17.0137 5.24292 17.6581 4.59863 18.453 4.59863C19.248 4.59863 19.8925 5.24292 19.8925 6.03794Z" fill="#98A2B3"/>
</g>
<defs>
<clipPath id="clip0_1701_13599">
<rect width="24" height="24" fill="white" transform="translate(0 0.444336)"/>
</clipPath>
</defs>
</svg>
`
        },
        {
           // img: 'fa fa-instagram fa-2x',
            name: 'Threads',
            url: 'https://www.threads.net/@taxmannindia?igshid=MzRlODBiNWFlZA==',
            svg: `
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="192px" height="192px" viewBox="0 0 192 192" enable-background="new 0 0 192 192" xml:space="preserve">
<g>
	<defs>
		<rect id="SVGID_1_" width="192" height="192"/>
	</defs>
	<clipPath id="SVGID_2_">
		<use xlink:href="#SVGID_1_"  overflow="visible"/>
	</clipPath>
	<path clip-path="url(#SVGID_2_)" d="M141.536,88.988c-0.825-0.396-1.667-0.778-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1
		c-0.113-0.001-0.226-0.001-0.34-0.001c-14.985,0-27.448,6.397-35.12,18.037l13.779,9.452c5.731-8.695,14.725-10.548,21.348-10.548
		c0.077,0,0.153,0,0.229,0c8.249,0.053,14.476,2.452,18.504,7.129c2.932,3.405,4.893,8.111,5.863,14.05
		c-7.313-1.243-15.224-1.626-23.68-1.141c-23.82,1.372-39.133,15.265-38.105,34.569c0.522,9.792,5.4,18.216,13.736,23.719
		c7.047,4.652,16.123,6.928,25.557,6.412c12.458-0.683,22.23-5.436,29.049-14.127c5.178-6.6,8.453-15.153,9.898-25.93
		c5.938,3.583,10.337,8.298,12.768,13.966c4.132,9.635,4.373,25.468-8.545,38.376c-11.319,11.308-24.927,16.2-45.488,16.351
		c-22.809-0.169-40.06-7.483-51.275-21.741C35.235,139.966,29.808,120.682,29.605,96c0.202-24.682,5.63-43.966,16.133-57.317
		C56.954,24.425,74.204,17.11,97.014,16.941c22.975,0.17,40.524,7.52,52.17,21.847c5.71,7.026,10.015,15.861,12.853,26.162
		l16.147-4.308c-3.44-12.68-8.854-23.606-16.219-32.668C147.035,9.607,125.202,0.195,97.069,0h-0.113
		C68.881,0.194,47.292,9.642,32.789,28.079C19.881,44.486,13.225,67.316,13,95.932L13,96L13,96.067
		c0.224,28.616,6.881,51.446,19.788,67.854C47.292,182.358,68.881,191.806,96.956,192h0.113c24.96-0.173,42.554-6.708,57.048-21.189
		c18.963-18.944,18.393-42.691,12.143-57.27C161.775,103.087,153.227,94.596,141.536,88.988 M98.44,129.507
		c-10.44,0.588-21.286-4.098-21.821-14.135c-0.396-7.442,5.296-15.746,22.461-16.735c1.966-0.113,3.895-0.169,5.789-0.169
		c6.235,0,12.069,0.606,17.371,1.766C120.265,124.935,108.661,128.946,98.44,129.507"/>
</g>
</svg>
            `
        },

        {
            // img: 'fa fa-facebook-official fa-2x',
             name: 'Facebook',
             url: 'https://www.facebook.com/taxmannindia',
             svg: `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
             <g clip-path="url(#clip0_1701_13593)">
             <path d="M24 12.4443C24 5.81691 18.6274 0.444336 12 0.444336C5.37258 0.444336 0 5.81691 0 12.4443C0 18.4338 4.3882 23.3983 10.125 24.2986V15.9131H7.07812V12.4443H10.125V9.80059C10.125 6.79309 11.9166 5.13184 14.6576 5.13184C15.9701 5.13184 17.3438 5.36621 17.3438 5.36621V8.31934H15.8306C14.34 8.31934 13.875 9.24441 13.875 10.1943V12.4443H17.2031L16.6711 15.9131H13.875V24.2986C19.6118 23.3983 24 18.4338 24 12.4443Z" fill="#98A2B3"/>
             </g>
             <defs>
             <clipPath id="clip0_1701_13593">
             <rect width="24" height="24" fill="white" transform="translate(0 0.444336)"/>
             </clipPath>
             </defs>
             </svg>
             `
         },
    ];


    static productArray: IFooterLinkModel[] = [
        {
            name: 'Premium',
            url: '/premium',
            isNew: true,
            externalLink: true,
            sameTab: true
        },
        {
            name: 'Research',
            url: '/research',
            sameTab: true,
            externalLink: true
        },
        // {
        //     name: 'Learning',
        //     url: '/learning'
        // },
        {
            name: 'Practice',
            url: '/practice'
        },
        {
            name: 'Learning',
            url: '/learning',
            sameTab: true,
            externalLink:true,
            isNew:true
        }
        ,
        {
            name: 'Advisory',
            url: '/advisory',
            sameTab: true,
            externalLink: true
        },
        {
            name: 'Academy',
            url: '/academy',
            sameTab: true,
            externalLink: true
        },
        {
            name: 'Compliance',
            url: '/compliance-etds',
        },
        {
            name: 'Bookstore',
            url: '/bookstore',
            sameTab: true,
            externalLink: true
        },
        {
            name: 'Students',
            url: '/students',
            sameTab: true,
            externalLink: true,
            
        },


        // {
        //     name: 'Virtual Books & Journals',
        //     //url: 'https://virtualbooks.taxmann.com/',
        //     //externalLink: true
        //     url: '/virtualbooks'
        // },
        
        // {
        //     name: 'Podcast',
        //     url: '/podcast'
        // },
        {
            name: 'Blog',
            url: 'https://www.taxmann.com/post/blog/',
            externalLink: true
        }
    ];

    static aboutCompanyArray: IFooterLinkModel[] = [
        {
            name: 'Home',
            url: '/home'
        },
        {
            name: 'About us',
            url: '/aboutus'
        },
        {
            name: 'Media Coverage',
            url: 'https://www.taxmann.com/post/press-release',
            externalLink: true
        },
        {
            name: 'Careers',
            url: '/careers'
        },
        {
            name: 'Sitemap',
            url: '/sitemap'
        }
    ];

    static cataloguedData: IFooterLinkModel[] = [
        {
            name: 'Academic',
            url: 'https://www.taxmann.com/BookStore/Catalogues/Acedemiccatalouge02032020.pdf',
            externalLink: true
        },
        {
            name: 'Professional',
            url: 'https://www.taxmann.com/BookStore/Catalogues/Proffessional-Catalogue%2029052020.pdf',
            externalLink: true
        },
        {
            name: 'NISM Certification Courses',
            url: 'https://www.taxmann.com/BookStore/Catalogues/03_NSIM%20Catalogue%20[Pgs%201-16]%20[6-5x9-25]_August%202019.pdf',
            externalLink: true
        },
        {
            name: 'LL.B. Series',
            url: 'https://www.taxmann.com/BookStore/Catalogues/LLb%20Series_(July%202018).pdf',
            externalLink: true
        },
        // {
        //     name: 'Taxmann Laws- February 2020',
        //     url: 'https://www.taxmann.com/BookStore/Catalogues/TaxmannsLaw_[Pgs%201-12_Size-7.75x10inch]_Feb2020_Final.pdf',
        //     externalLink: true
        // },
    ]


    static businessAndSupportArray: IFooterLinkModel[] = [
        {
            name: 'Sell with Taxmann',
            url: '/dealer/join'
        },
        {
            name: 'Locate Dealers',
            url: '/dealer/search'
        },
        {
            name: 'Locate Representatives',
            url: '/dealer/search',
            queryParams: {
                type: 'representative'
            }
        },
        {
            name: 'FAQs',
            url: '/faqs'
        },
        {
            name: 'Contact Us',
            url: '/contactus'
        },
        {
            name: 'Downloads',
            url: '/downloads'
        },
        {
            name: 'CD Key Activation',
            url: 'https://support.taxmann.com/onesolution-cd-key-activation-code.aspx',
            externalLink: true
        }
    ];


    static legalArray: IFooterLinkModel[] = [
        {
            name: 'Fair Usage Policy',
            url: '/legal/fair-usage-policy'
        },
        {
            name: 'Privacy Policy',
            url: '/legal/privacy-policy'
        },
        {
            name: 'Return Policy',
            url: '/legal/return-policy'
        },
        {
            name: 'Payment Terms',
            url: '/legal/payment-terms'
        },        
        {
            name: 'EULA',
            url: '/legal/end-user-licence-agreement'
        },
        {
            name: 'Disclaimer',
            url: '/legal/legal-disclaimer'
        },
    
    ];

    static bookstoreSupportArray: IFooterLinkModel[] = [
        {
            name: 'Express Delivery | Secured Payment',
            url: ''
        },

        {
            name: 'Free Shipping in India on order(s) above <strong>  ₹500  </strong>',
            url: '',
            isHtml: true,
        },
        {
            name: '',            
            url: '',
            isHtml: true,
        }];


}
